<script>
import PickupDetails from '@/views/Application/CustomerService/Pickups/Pickup/Details'

export default {
  extends: PickupDetails,
  data () {
    return {
      breadcrumb: {
        name: 'Details',
        route: { name: 'customerservice-accounts-account-pickups-pickup-details', params: this.$route.params }
      }
    }
  }
}
</script>
